import React, { useState, useEffect } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import { REFERRAL_SOURCE_TYPE } from "../../../../constants/config.constants";

const ReferralSourceAddModal = ({
  isOpen,
  edit,
  clearInput,
  onUpdate,
  onSave,
  setOpen,
  data,
  setData,
}) => {
  const [errorMsg, setErrorMsg] = useState("");
  const [referralTypes, setReferralTypes] = useState([]);

  const handleChange = (e) => {
    const tmpData = { ...data };
    if (e.target.name === "contact_phone") {
      tmpData[e.target.name] = formatPhoneNumber(e.target.value);
    } else {
      tmpData[e.target.name] = e.target.value;
    }
    setData(tmpData);
  };

  const formatPhoneNumber = (input) => {
    const cleaned = ("" + input).replace(/\D/g, "");

    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    return match
      ? [match[1], match[2], match[3]].filter(Boolean).join("-")
      : "";
  };

  useEffect(() => {
    setReferralTypes(
      Object.keys(REFERRAL_SOURCE_TYPE).map((e) => ({
        key: e,
        value: REFERRAL_SOURCE_TYPE[e],
      }))
    );
  }, []);

  return (
    <ReusableModal
      open={isOpen}
      title={edit ? "Edit referral source" : "Add new referral source"}
      onClose={() => {
        setOpen(false);
        clearInput();
      }}
    >
      <div className="flex flex-col items-center min-w-[480px]">
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <div className="flex flex-col gap-4 p-6 overflow-auto max-h-[calc(100vh-200px)]">
          <div className="flex flex-row w-full gap-4">
            <div className="flex flex-col w-full gap-2">
              <label htmlFor="name" className="m-0 text-base font-semibold">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Referral Source"
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                value={data?.name}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="flex flex-row w-full gap-4">
            <div className="flex flex-col w-1/2  gap-2">
              <label htmlFor="type" className="m-0 text-base font-semibold">
                Type/Category
              </label>
              <select
                id="type"
                name="type"
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                value={data?.type || ""}
                onChange={handleChange}
                disabled={data?.ref_type === "community"}
              >
                <option key="" value="">
                  Select Referral Type
                </option>
                {referralTypes?.map((type) => (
                  <option key={type?.key} value={type?.key}>
                    {type?.value}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col w-1/2 gap-2">
              <label
                htmlFor="contact_name"
                className="m-0 text-base font-semibold"
              >
                Contact Name
              </label>
              <input
                type="text"
                id="contact_name"
                name="contact_name"
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                placeholder="Enter Contact Name"
                value={data?.contact_name}
                onChange={handleChange}
                disabled={data?.ref_type === "community"}
              />
            </div>
          </div>
          <div className="flex flex-row w-full gap-4">
            <div className="flex flex-col w-1/2 gap-2">
              <label
                htmlFor="contact_phone"
                className="m-0 text-base font-semibold"
              >
                Contact Phone
              </label>
              <input
                type="tel"
                id="contact_phone"
                name="contact_phone"
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                placeholder="xxx-xxx-xxxx"
                value={data?.contact_phone}
                disabled={data?.ref_type === "community"}
                onChange={(e) => {
                  if (e.target.value.length >= 13) {
                    return;
                  }
                  handleChange(e);
                }}
              />
            </div>
            <div className="flex flex-col w-1/2 gap-2">
              <label
                htmlFor="contact_email"
                className="m-0 text-base font-semibold"
              >
                Contact Email
              </label>
              <input
                type="email"
                id="contact_email"
                name="contact_email"
                className="w-full p-2 border-[1px] border-primarygray rounded-md outline-none"
                placeholder="example@mail.com"
                value={data?.contact_email}
                onChange={handleChange}
                disabled={data?.ref_type === "community"}
              />
            </div>
          </div>
        </div>
        {errorMsg && <div className="text-red-500">{errorMsg}</div>}
        <div className="w-full d-flex justify-center mb-4">
          <button
            disabled={
              !data.name || (data.ref_type !== "community" && !data.type)
            }
            className="w-75 disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-2 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
            onClick={async () => {
              try {
                if (edit) {
                  await onUpdate();
                } else {
                  await onSave();
                }
                setOpen(false);
                clearInput();
              } catch (error) {
                setErrorMsg(error.message);
              }
            }}
          >
            {edit ? "Save" : "Add"}
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ReferralSourceAddModal;
